import React, { useEffect } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { updateFilesFiltered, updateReviewInfo } from './thunks';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import './OutputFileFilter.css';

const OutputFileFilter = ({
  mode, allowEdit = false, files = [], userInfo, reviewInfo,
  startUpdateFilesFiltered, startUpdateReviewInfo }) => {

  useEffect(() => {
  }, []);

  const onOptionChange = (event) => {
    event.preventDefault();
    let filter = event.target.value;
    // console.log('>>> startUpdateFilesFiltered:', files, filter);
    startUpdateFilesFiltered({files, filter});
  };

  const onReviewDownloadClick = (event) => {
    event.preventDefault();
    startUpdateReviewInfo({ showFileDownloadDialog:true });
  };

  const checkDownloadDisplay = (mode) => {
    let result = false;
    if (mode === "review" && userInfo.allowDownload) {
      result = true;
    }
    return result;
  };
  
  const content = (
    <div className="file-list-filter">
      <InputGroup>
        <InputGroup.Prepend>
          <InputGroup.Text>
            <img src="/images/filter-18.png" />
          </InputGroup.Text>
        </InputGroup.Prepend>
        <Form.Control as="select" onChange={onOptionChange}  >
          <option key="all" value="all" selected >All</option>
          <option key="require_change" value="require_change" >Require Change</option>
          <option key="table" value="table" >Table</option>
          <option key="figure" value="figure" >Figure</option>
          <option key="listing" value="listing" >Listing</option>
        </Form.Control>
        { checkDownloadDisplay(mode) ?
        <InputGroup.Append>
          <InputGroup.Text>
            <img className="review-download-link" src="/images/download-20.png"
              onClick={onReviewDownloadClick} />
          </InputGroup.Text>
        </InputGroup.Append>
        : ""
        }
      </InputGroup>

    </div>
  );
  return content;
}

const mapState = state => ({
  files: state.files,
  userInfo: state.userInfo,
  reviewInfo: state.reviewInfo,
})

const mapDispatch = dispatch => ({
  startUpdateFilesFiltered: (data) => dispatch(updateFilesFiltered(data)),
  startUpdateReviewInfo: (data) => dispatch(updateReviewInfo(data)),
})

export default connect(mapState, mapDispatch)(OutputFileFilter);
